import { render } from "./QueueTelatv.vue?vue&type=template&id=173b1da0&scoped=true"
import script from "./QueueTelatv.vue?vue&type=script&lang=js"
export * from "./QueueTelatv.vue?vue&type=script&lang=js"

import "./QueueTelatv.vue?vue&type=style&index=0&id=173b1da0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173b1da0"]])

export default __exports__